
/**
* Licensed Materials - Property of IBM
* IBM Cognos Products: ba-dashboard-core
* (C) Copyright IBM Corp. 2018, 2022
* US Government Users Restricted Rights - Use, duplication or disclosure restricted by GSA ADP Schedule Contract with IBM Corp.
*/
define({
	// Application Title
	'appTitle': 'Project Gemini',
	'appExit': 'Siirry aloitussivulle',


	'widgetsListLabel': 'Pienoisohjelmien luettelo. Valitse pienoisohjelma ja lisää painamalla Enter-näppäintä.',

	// no longer used in this component, moved to dashboard-livewidget.
	// please don't remove from here, or will break R8
	//General
	'listSeparator': ', ',
	'pointSeparator': ':',

	'insync': 'Ajan tasalla',
	'dirty': 'Ei ajan tasalla',
	'conflict': 'Ristiriita näkymän tallennuksessa',
	'error': 'Ongelma näkymän tallennuksessa',
	'failure': 'Yhteyden muodostus palvelimeen ei onnistu',
	'saveFailed': 'Näkymän tallennus ei onnistu',

	'wa_insync': 'Tallennettu',
	'wa_conflict': 'Ristiriita näkymän tallennuksessa',
	'wa_error': 'Näkymän tallennus ei onnistu',
	'wa_failure': 'Yhteyden muodostus palvelimeen ei onnistu',

	// Menu Labels
	'changeDisplay': 'Vaihda näyttö',
	'changeToColumnChart': 'Muuta pylväskaavioksi',
	'changeToBubbleChart': 'Muuta kuplakaavioksi',
	'toggleMoveHandles': 'Vaihda siirtokahvat',
	'undo': 'Kumoa',
	'redo': 'Tee uudelleen',
	'mode': 'Vaihda tilaa',

	'untitled': 'Nimetön',
	'remove': 'Poista',
	'editTitle': 'Muokkaa otsikkoa',
	'edit': 'Muokkaa',
	'done': 'Valmis',

	// Data tray
	'dataTrayHandleOpenLabel': 'Avaa tietovalikoima',
	'dataTrayHandleCloseLabel': 'Sulje tietovalikoima',

	// Dialogs
	'dlg_loading': 'Ladataan...',
	'dlg_ok': 'OK',
	'dlg_create': 'Luo',
	'dlg_cancel': 'Peruuta',
	'dlg_close': 'Sulje',
	'dlg_update': 'Päivitä',
	'dlg_renameBoardTitle': 'Nimeä tämä objekti uudelleen',
	'dlg_renameDatasetTitle': 'Nimeä tämä tietojoukko uudelleen',
	'dlg_renameSceneTitle': 'Nimeä tämä kohtaus uudelleen',
	'dlg_NameLabel': 'Nimi:',
	'dlg_NewNameLabel': 'Uusi nimi:',
	'dlg_DefaultNameWithDataSet': 'Näkymä %{name}',
	'dlg_ShareTitle': 'Määritä sisältö yhteiskäyttöön',
	'dlg_UnshareTitle': 'Poista sisällön yhteiskäyttö',
	'dlg_ShareUser': 'Käyttäjätunnus:',
	'dlg_NewColumnLabel': 'Uuden laskutoimituksen nimi',

	'dlg_new': 'Uusi...',
	'dlg_open': 'Avaa...',
	'dlg_makeACopy': 'Tee kopio',
	'dlg_rename': 'Nimeä uudelleen...',
	'dlg_moreToCome': 'Lisää toimintoja tulossa...',

	'dlg_use': 'Käytä',

	'dlg_RelinkDatasetTitle': 'Korvaa tietojoukko %{datasetName} kohteella...',

	'open_error': 'Näkymää avattaessa havaittiin ongelma.',

	// Delete Board
	'del_dialogTitle': 'Poiston vahvistus',
	'del_itemMsg': 'Haluatko varmasti poistaa kohteen %{name}?',
	'del_itemsMsg': 'Haluatko varmasti poistaa %{count} kohdetta?',
	'del_deleteErr': 'Kohteen %{name} poisto ei onnistu',

	// List Sorting
	'dlg_ascending': 'nouseva',
	'dlg_descending': 'laskeva',
	'dlg_custom': 'mukautettu',
	'dlg_none': 'ei mitään',

	// Input Placeholders
	// no longer used in this component, moved to dashboard-livewidget.
	// please don't remove from here, or will break R8
	'search': 'Hae',

	'searchHint': 'Hae kaikista tiedoista',
	'clearSearchResult': 'Tyhjennä hakutulokset',
	// Shapes and shapes categories
	// Basic shapes
	'shapesCircle': 'Ympyrä',
	'shapesHexagon': 'Kuusikulmio',
	'shapesLine': 'Viivakaavio',
	'shapesOctagon': 'Kahdeksankulmio',
	'shapesPentagon': 'Viisikulmio',
	'shapesSquare': 'Neliö',
	'shapesTriangle': 'Kolmio',
	'shapesDiamond': 'Vinoneliö',
	'shapesTitle': 'Muodon ominaisuudet', // TODO: becomes "Shape" when FF 'PropertiesV2' is enabled


	// Advanced shapes
	'shapesSquareRounded': 'Pyöristetty neliö',
	'shapesStar': 'Tähti',
	'shapesChevron': 'Nuolikuviointi',
	'shapesBadge_ribbon': 'Merkin nauha',
	'shapesBadge': 'Merkki',
	'shapesHeart': 'Sydän',
	'shapesExclamation': 'Huutomerkki',
	'shapesTrendingup': 'Nouseva suuntaus',
	'shapesTrendingdown': 'Laskeva suuntaus',
	'shapesX': 'X',

	// People shapes
	'shapesPeopleCat': 'Ihmisiä',
	'shapesFemale': 'Nainen',
	'shapesHappyface': 'Iloiset kasvot',
	'shapesMale': 'Mies',
	'shapesMan': 'Mies',
	'shapesNeutralface': 'Neutraalit kasvot',
	'shapesSadface': 'Surulliset kasvot',
	'shapesShakehands': 'Kädenpuristus',
	'shapesThumbsdown': 'Peukalot alaspäin',
	'shapesThumbsup': 'Peukalot ylöspäin',
	'shapesWoman': 'Nainen',

	// Weather and places
	'shapesPlacesWeatherCat': 'Paikkoja ja säätiloja',
	'shapesCity': 'Paikkakunta',
	'shapesCloud': 'Pilvinen',
	'shapesEducation': 'Koulutus',
	'shapesGovernment': 'Hallinto',
	'shapesHalfcloud': 'Puolipilvinen',
	'shapesHouse': 'Talo',
	'shapesMoon': 'Kuu',
	'shapesRain': 'Sade',
	'shapesSunny': 'Aurinkoinen',

	//Vehicles
	'shapesVehiclesCat': 'Ajoneuvot',
	'shapesAirplane': 'Lentokone',
	'shapesCar': 'Auto',
	'shapesShip': 'Laiva',
	'shapesShoppingcart': 'Ostoskärry',
	'shapesTrain': 'Juna',
	'shapesTruck': 'Kuorma-auto',

	//Objects
	'shapesObjectsCat': 'Esineitä',
	'shapesBook': 'Kirja',
	'shapesBriefcase': 'Salkku',
	'shapesCalendar': 'Kalenteri',
	'shapesCheck': 'Sekki',
	'shapesClock': 'Kello',
	'shapesDesktop': 'Tietokone',
	'shapesDocument': 'Asiakirja',

	'shapesFood': 'Ruoka',
	'shapesGear': 'Hammaspyörä',
	'shapesHealth': 'Terveys',

	'shapesIdea': 'Idea',
	'shapesMobile': 'Matkapuhelin',
	'shapesMoney_bill': 'Seteli',
	'shapesMoney_coin': 'Kolikko',
	'shapesPiggybank': 'Säästöpossu',
	'shapesStackofpaper': 'Paperipino',
	'shapesStickynote1': 'Tarralappu 1',
	'shapesStickynote2': 'Tarralappu 2',
	'shapesTarget': 'Tavoite',
	'shapesTool': 'Työkalu',

	'shapesUmbrella': 'Sateenvarjo',

	'shapesBrain': 'Aivot',
	'shapesSkull': 'Pääkallo',
	'shapesEye': 'Silmä',

	// Arrows shapes
	'shapesArrowsCat': 'Nuolet',
	'shapesRightArrow': 'Oikea nuoli',
	'shapesLeftArrow': 'Vasen nuoli',
	'shapesDoubleArrow': 'Kaksipäinen nuoli',
	'shapesCurvedArrow': 'Kaareva nuoli',

	// Callouts shapes
	'shapesCalloutsCat': 'Kuvatekstit',
	'shapesRectCallout': 'Kuvateksti',

	// Images
	'imagesCat': 'Kuvat',
	'imageWidgetTitle': 'Kuvapienoisohjelma',
	'imgUrl': 'Kuvan URL-osoite',
	'noImgSelected': 'Kuvaa ei ole valittu',
	'enterImgUrl': 'Anna kuvan URL-osoite',
	'imgPasteLink': 'Liitä URL-osoite ja tallenna se painamalla Enter-näppäintä.',
	'imgResizeToFit': 'Muuta kokoa kuvan kokoon sopivaksi',
	'imgHeight': 'Korkeus:',
	'imgWidth': 'Leveys:',
	'imgTransparency': 'Läpinäkyvyys:',
	'imgMissingUrl': 'Kuvan URL-osoite puuttuu.',
	'imgUrlValidationError': 'Kuvan URL-osoite ei kelpaa.',
	'imgUrlInvalidDomainError': 'Kuvan URL-osoite viittaa verkkoalueeseen, jota pääkäyttäjä ei ole hyväksynyt. Pääkäyttäjän hyväksymät verkkoalueet ovat %{domains}.',
	'notPositiveNumberError': 'Vain positiiviset arvot',

	// line shape
	'propStrokeWidth': 'Viivan paksuus',
	'propStrokeDashArray': 'Viivan tyyli',
	'propStrokeSolidline': 'Yhtenäinen viiva',
	'propStrokeLineCap': 'Viivan pää',
	'propStrokeLineCapButt': 'Perä',
	'propStrokeLineCapRound': 'Pyöreä',
	'propStrokeLineCapSquare': 'Neliö',

	// Data player widget
	// no longer used in this component, moved to dashboard-livewidget.
	// please don't remove from here, or will break R8
	'playButtonLabel': 'Toista',
	'dataPlayerValueListLabel': 'Tietojen toistimen arvot',
	// Text Widget
	'textWidgetTitle': 'Teksti-pienoisohjelma',
	'textStyle': 'Tyylit',
	'textStyleDescription': 'Esimuotoillut tekstityylit',
	'textTitleStyle': 'Otsikko',
	'textTitleSmallStyle': 'Pieni otsikko',
	'textSubtitleStyle': 'Alaotsikko',
	'textBodyStyle': 'Tekstiosa',
	'textBodySmallStyle': 'Pieni tekstiosa',
	'textCaptionStyle': 'Kuvateksti',
	'textQuoteStyle': 'Lainaus',
	'textQuoteSmallStyle': 'Pieni lainaus',
	'textResponsiveStyle': 'Sovita koko automaattisesti',
	// TODO: Carbon design removes Font Family subClass, no longer needed when FF 'PropertiesV2' is enabled
	// START: Remove FontFamilySubClass
	'textFontFamilySubClassHairline': 'Hiusviiva',
	'textFontFamilySubClassThin': 'Ohut',
	'textFontFamilySubClassThinItalic': 'Ohut kursivoitu',
	'textFontFamilySubClassExtraLight': 'Hyvin ohut',
	'textFontFamilySubClassExtraLightItalic': 'Hyvin ohut kursivoitu',
	'textFontFamilySubClassLight': 'Ohuehko',
	'textFontFamilySubClassLightItalic': 'Ohuehko kursivoitu',
	'textFontFamilySubClassRegular': 'Normaali',
	'textFontFamilySubClassRegularItalic': 'Tavallinen kursivoitu',
	'textFontFamilySubClassItalic': 'Kursivoitu',
	'textFontFamilySubClassMedium': 'Keskikokoinen',
	'textFontFamilySubClassMediumItalic': 'Keskikokoinen kursivoitu',
	'textFontFamilySubClassHeavy': 'Paksu',
	'textFontFamilySubClassHeavyItalic': 'Paksu kursivoitu',
	'textFontFamilySubClassDemiBold': 'Puolilihavoitu',
	'textFontFamilySubClassDemiBoldItalic': 'Puolilihavoitu kursivoitu',
	'textFontFamilySubClassBold': 'Lihavoitu',
	'textFontFamilySubClassBoldItalic': 'Lihavoitu kursivoitu',
	'textFontFamilySubClassExtraBold': 'Hyvin paksu',
	'textFontFamilySubClassExtraBoldItalic': 'Hyvin paksu kursivoitu',
	'textFontFamilySubClassBlack': 'Musta',
	'textFontFamilySubClassBlackItalic': 'Musta kursivoitu',
	'textFontFamilySubClassStencil': 'Stencil-fontti',
	// END: Remove FontFamilySubClass

	'responsiveCoachmarkTitle': 'Automaattisesti kokoon sovitettu fontti',
	'responsiveCoachmarkContents': 'Fonttikoko muuttuu automaattisesti, kun muutat kokoa tässä tekstityypissä. Voit asettaa fontin koon tekstin ominaisuuksissa.',

	'propText': 'Tekstin tiedot', // TODO: no longer needed when FF 'PropertiesV2' is enabled, replaced with 'Details'
	'propTextReturn': 'Tekstin ominaisuudet', // TODO: becomes "Text" when FF 'PropertiesV2' is enabled

	'textFontSize': 'Fonttikoko',
	'textFontFamily': 'Fonttiperhe',
	'textFontWeight': 'Fontin painotus', // TODO: no longer needed when FF 'PropertiesV2' is enabled
	'textFontColor': 'Väri',
	'textLineHeight': 'Rivikorkeus',
	'textIndentation': 'Sisennys',
	'textIncreaseIndentation': 'Suurenna sisennystä',
	'textDecreaseIndentation': 'Pienennä sisennystä',
	'textInnerMargins': 'Sisämarginaalit (px)',

	// Widget Properties
	'propImageLink': 'Kuvan linkki',
	'propMissingURL': 'Kirjoita URL-osoite',
	'propImgTop': 'Kuvan ominaisuudet', // TODO: becomes "Image" when FF 'PropertiesV2' is enabled
	'propGeneralReturn': 'Yleiset ominaisuudet', // TODO: no longer needed when FF 'PropertiesV2' is enabled
	'propStyle': 'Yleiset', // TODO: no longer needed when FF 'PropertiesV2' is enabled
	'propStyleReturn': 'Yleiset', // TODO: no longer needed when FF 'PropertiesV2' is enabled
	'propFillColor': 'Täyttöväri', // TODO: becomes "Background color" when FF 'PropertiesV2' is enabled
	'propTextColor': 'Tekstin väri', // TODO: no longer needed when FF 'PropertiesV2' is enabled
	'propBorderColor': 'Reunuksen väri',
	'propBorderRadius': 'Kulman säde (px)',
	'propShowBorderInPreview': 'Näytä valittu reunus esikatselussa',
	'propMaintainAxisScales': 'Säilytä akselin mittakaava',
	'propShowItemLabel': 'Näytä kohteen nimike',
	'propHideLegend': 'Piilota selite',
	'propColorPalette': 'Paletti',
	'propLegendPosition': 'Selitteen sijainti',
	'propHideAxisTitleLabels': 'Piilota akselin otsikot',
	'propLineColor': 'Viivan väri',
	'propBubbleColor': 'Kuplan väri',
	'propInterpolation': 'Pyöristetyt viivat',
	'propElementColor': 'Visualisointielementin väri',
	'propSymbolShape': 'Symbolin muoto',
	'propHeatScalePalette': 'Värien järjestys',
	'propHeatScalePalette_tooltipDarkerForLowerValue': 'Tummemmat värit vastaavat pienempiä arvoja.',
	'propHeatScalePalette_tooltipDarkerForHigherValue': 'Tummemmat värit vastaavat suurempia arvoja.',
	'propImageDetails': 'Kuvan tiedot', // TODO: no longer needed when FF 'PropertiesV2' is enabled
	'propWebDetails': 'Web-sivun tiedot', // TODO: no longer needed when FF 'PropertiesV2' is enabled
	'propMediaDetails': 'Multimediasisällön tiedot', // TODO: no longer needed when FF 'PropertiesV2' is enabled
	'propPasteLink': 'Anna URL-osoite ja paina Enter-näppäintä.',

	//Layout Properties
	'sectionName_positionAndStyle': 'Sijainti ja tyyli',
	'propPositionLabel': 'Sijainti', // TODO: no longer needed when FF 'PropertiesV2' is enabled
	'propPositionXAxis_v1': 'X',
	'propPositionXAxis': 'Sijainti X-akselilla (%{unit})',
	'propPositionYAxis_v1': 'Y',
	'propPositionYAxis': 'Sijainti Y-akselilla (%{unit})',
	'propResizeLabel': 'Koko', // TODO: no longer needed when FF 'PropertiesV2' is enabled
	'propResizeWidth_v1': 'Leveys',
	'propResizeWidth': 'Leveys (%{unit})',
	'propResizeHeight_v1': 'Korkeus',
	'propResizeHeight': 'Korkeus (%{unit})',
	'propRotateLabel_v1': 'Kierrä',
	'propRotateLabel': 'Kierrä (°)',
	'propRotateAngle': 'Kulma', // TODO: no longer needed when FF 'PropertiesV2' is enabled

	// no longer used in this component, moved to dashboard-livewidget.
	// please don't remove from here, or will break R8
	'propScaleLabel': 'Kuvakkeiden määrä',
	'propScaleDescription': 'Valitse kuvakkeiden määrä',
	'propScaleFew': 'Pieni',
	'propScaleDefault': 'Oletus',
	'propScaleMany': 'Suuri',

	/* PropertyV2 controls */
	// InputLabel - number
	'propInputLabel_number_invalid': 'Arvon on oltava numeerinen',

	'mediaAriaLabel': 'URL-osoitteen syöte',
	'dropdownAriaLabel' : 'Avattava luettelo',
	'ariaGroupLabel': 'Avattavan luettelon luokka: %{cateoryLabel} kohde: %{itemLabel}. Laajenna painamalla alanuolinäppäintä. Siirry painamalla ylänuoli- tai alanuolinäppäimiä tai kutista painamalla ESC-näppäintä.',
	'colorNoFillLabel': 'Ei täyttöä',
	// Timer
	// no longer used in this component, moved to dashboard-livewidget.
	// please don't remove from here, or will break R8
	'lastRefresh': 'Päivitetty viimeksi: %{timeInterval} sitten',
	'widgetTimer': 'Pienoisohjelman ajastin',

	// Theme colors
	'transparent': 'Ei väriä',
	'white': 'Valkoinen',
	'lightGrey': 'Vaaleanharmaa',
	'grey': 'Harmaa',
	'darkGrey': 'Tummanharmaa',
	'black': 'Musta',
	'lightBlue': 'Vaaleansininen',
	'blue': 'Sininen',
	'darkBlue': 'Tummansininen',
	'yellow': 'Keltainen',
	'orange': 'Oranssi',
	'lime': 'Limetinvihreä',
	'green': 'Vihreä',
	'peach': 'Persikka',
	'red': 'Punainen',
	'violet': 'Violetti',
	'aqua': 'Kirkas vedensininen',
	'purple': 'Purppura',
	'plum': 'Luumunpunainen',
	'gray10': 'Harmaa 10',
	'gray20': 'Harmaa 20',
	'gray30': 'Harmaa 30',
	'gray50': 'Harmaa 50',
	'gray60': 'Harmaa 60',
	'gray70': 'Harmaa 70',
	'gray80': 'Harmaa 80',
	'gray90': 'Harmaa 90',
	'gray100': 'Harmaa 100',
	'blue50': 'Sininen 50',
	'blue60': 'Sininen 60',
	'blue70': 'Sininen 70',
	'green40': 'Vihreä 40',
	'green50': 'Vihreä 50',
	'red50': 'Punainen 50',
	'red60': 'Punainen 60',


	//Theme Palette Labels
	'themeLabel': 'Teema',
	'paletteLabel': 'IBM-paletti %{number}',
	'heatPaletteLabel': 'IBM-lämpökaaviopaletti %{number}',
	'conditionalPaletteLabel': 'Ehdollinen IBM-paletti %{number}',
	'carbonPaletteXLight': 'Carbon X, vaalea',
	'carbonPaletteXDark': 'Carbon X, tumma',
	'carbonPalettePurple': 'Purppura',
	'carbonPaletteTeal': 'Sinivihreä',
	'carbonPaletteCyan': 'Syaani',
	'carbonPaletteMagenta': 'Magenta',
	'carbonPalettePurpleTeal': 'Purppura Sinivihreä',
	'carbonPaletteCyanMagenta': 'Syaani Magenta',
	'carbonPaletteGreenRed': 'Vihreä Punainen',
	'carbonPaletteGreenYellowRed': 'Vihreä Keltainen Punainen',
	'carbonPalettePurpleTealConvergent': 'Purppura Sinivihreä Lähenevä',
	'carbonPaletteCyanMagentaConvergent': 'Syaani Magenta Lähenevä',

	// TODO: Remove the following strings when the colour palette UI is removed
	'userPaletteColor_lightTheme': 'Vaalea IBM-paletti',
	'userPaletteColor_defaultTheme': 'IBM-oletuspaletti',
	'userPaletteColor_darkTheme': 'Tumma IBM-paletti',

	// Dashboard
	'propDashboardBackgroundColor': 'Taustaväri',
	'propLayoutPositioning': 'Asettelun sijoittelu',
	'propLayoutRelative': 'Suhteellinen',
	'propLayoutAbsolute': 'Absoluuttinen',
	'propLayoutPositioningCoachmarkTitle': 'Asettelun tyylin valinta',
	'propLayoutPositioningCoachmarkContent': 'Suhteellisessa asettelussa pienoisohjelmien koko ja sijainti säädetään näyttöön sopivaksi. Absoluuttisessa asettelussa pienoisohjelmat näkyvät näytön koosta riippumatta täsmälleen niin ja sen kokoisina kuin asetat ne näkymään.',
	'gridText': 'Näytä ruudukko',
	'snapText': 'Kohdista ruudukkoon',
	'snapObjectsText': 'Kohdista objektiteihin',
	'fitPageText': 'Sovita sivuun',
	'gridLabel': 'Ruudukko',
	'heightUnit': 'k',
	'widthUnit': 'l',
	'pixelUnit': 'px',
	'propPageSizeLabel': 'Sivun koko',
	'propPageSizePresetAriaLabel': 'Sivun koon esiasetus',
	'propPageSizePreset_v1': 'Esiasetus',
	'propPageSizePreset': 'Sivun koko',
	'propPageSizePresetCustom': 'Mukautettu',
	'propPageSizePreset16x9': 'Näyttö 16:9',
	'propPageSizePreset4x3': 'Näyttö 4:3',
	'propPageSizePresetInfographic': 'Infografiikka',
	'propPageSizeWidth_v1': 'Leveys',
	'propPageSizeWidth': 'Leveys (px)',
	'propPageSizeHeight_v1': 'Korkeus',
	'propPageSizeHeight': 'Korkeus (px)',
	'propPageSizeWidthAriaLabel': 'Sivun leveys',
	'propPageSizeHeightAriaLabel': 'Sivun korkeus',
	'propPageSizeAdjustedMessage': 'Sivun kokoa on suurennettu, koska merkintä oli pienempi kuin vähimmäisarvo tai se ei olisi mahtunut mittatietotauluun.',
	'propTabShow': 'Näytä välilehdet',
	'propShowTabsInPreview': 'Näytä välilehdet esikatselussa',
	'multilingualDashboardsLabel': 'Kielet',
	'multilingualDashboardsDefault': '%{defaultLanguage} - Oletus',
	'multilingualDashboardsAddLinkText': 'Lisää toinen kieli',
	'multilingualDashboardsSelect': 'Valitse',
	'multilingualDashboardsButtonLabel': 'Lisää',
	'multilingualDashboardTranslationMode': 'Olet nyt käännöstilassa (%{currentLanguage})',
	'multilingualDashboardTranslationDone': 'Valmis',
	'multilingualDashboardRemainingStrings': '%{numTranslationsLeft} käännöstä jäljellä',
	'multilingualDashboardRemainingString': '1 käännös jäljellä',
	'multilingualDashboardsSetDefault': 'Määritä oletuskieli',
	'multilingualDashboardIconMore': 'Lisää toimintoja kielelle %{currentLanguage}',
	'multilingualDashboardIconTranslatableArea': 'Käännettävissä oleva alue',
	'multilingualDeleteTitle': 'Poista kieli',
	'multilingualDeleteLanguageWarning': 'Haluatko varmasti poistaa kielen %{language}?',
	'multilingualSelectLanguage': 'Valitse kieli',
	'confirmLayoutStyleUpgradeTitle': 'Ota käyttöön kaikissa välilehdissä',
	'confirmLayoutStyleUpgrade': 'Käytetäänkö tätä asettelun tyyliä kaikissa mittatietotaulusi välilehdissä?',
	'defaultBackgroundColorLabel': 'Oletus',

	//Tabs
	'tabDeleteDialogPrimaryButton': 'Poista',
	'tabDeleteDialogTitle': 'Haluatko poistaa tämän välilehden?',
	'tabDeleteDialogMessage': 'Myös välilehden kaikki sisältö poistetaan.',

	// Vis widget
	'propVisTypeReturn': 'Visualisointityypit',
	'propVisDetails': 'Tiedot',

	// Alignment picker
	'propAlignPickTop': 'Tasaa yläreunaan',
	'propAlignPickRight': 'Tasaa oikealle',
	'propAlignPickBottom': 'Tasaa alareunaan',
	'propAlignPickLeft': 'Tasaa vasemmalle',
	'propAlignPickCenter': 'Tasaa keskelle',
	'propAlignPickMiddle': 'Keskitasaus',
	'propAlignPicker': 'Vaakatasaus',
	'propVerticalAlignPicker': 'Pystytasaus',

	// Toolbar picker
	'propToolbarPickBold': 'Lihavoitu',
	'propToolbarPickUnderline': 'Alleviivaus',
	'propToolbarPickItalic': 'Kursivoitu',
	'propToolbarPickJustifyLeft': 'Tasaa vasemmalle',
	'propToolbarPickJustifyCenter': 'Tasaa keskelle',
	'propToolbarPickJustifyRight': 'Tasaa oikealle',
	'propToolbarPickJustify': 'Tasattu',

	'propList': 'Luettelo',
	'propOrderedList': 'Järjestetty luettelo',
	'propUnorderedList': 'Järjestämätön luettelo',

	// Symbol shapes
	'propCircle': 'Ympyrä',
	'propTriangle': 'Kolmio',
	'propSquare': 'Neliö',
	'propRect': 'Suorakulmio',
	'propStar': 'Tähti',
	'propCross': 'Risti',
	'propPlus': 'Plus',
	'propPoly': 'Monikulmio',


	// True and false selection
	'propTrue': 'Tosi',
	'propFalse': 'Epätosi',

	// Position selection
	'propLeft': 'Vasemmalla',
	'propRight': 'Oikealla',
	'propTop': 'Ylhäällä',
	'propBottom': 'Alhaalla',

	// Interpolation options
	'propSmooth': 'Sileä',
	'propStraight': 'Suora',

	// indentedListView
	// no longer used in this component, moved to dashboard-livewidget.
	// please don't remove from here, or will break R8
	'srILVTreeLabel': 'Luettelo', // screen reader label for tree role

	// widget move
	'srWidgetMoveLeft': 'Siirrä vasemmalle', // screen reader
	'srWidgetMoveUp': 'Siirrä ylös', // screen reader
	'srWidgetMoveRight': 'Siirrä oikealle', // screen reader
	'srWidgetMoveDown': 'Siirrä alas', // screen reader

	// widget resize
	'srWidgetResizeBigger': 'Suurenna kokoa samassa suhteessa', // screen reader
	'srWidgetResizeSmaller': 'Pienennä kokoa samassa suhteessa', // screen reader
	'srWidgetResizeBiggerV': 'Suurenna kokoa pystysuunnassa', // screen reader
	'srWidgetResizeSmallerV': 'Pienennä kokoa pystysuunnassa', // screen reader
	'srWidgetResizeBiggerH': 'Suurenna kokoa vaakasuunnassa', // screen reader
	'srWidgetResizeSmallerH': 'Pienennä kokoa vaakasuunnassa', // screen reader

	// widget rotate
	'srWidgetRotateCW': 'Kierrä myötäpäivään', // screen reader
	'srWidgetRotateCCW': 'Kierrä vastapäivään', // screen reader

	// Recommended types
	'visChange': 'Vaihda visualisointi',

	// Visualization
	// no longer used in this component, moved to dashboard-livewidget.
	// please don't remove from here, or will break R8
	'visualizationLabel': 'Visualisointi',
	'chartLabel': 'Kaavio %{chartName}',
	'dataWidgetDescription': '%{widgetLabel}: %{columnNames}',
	'f12KeyDescription': 'Siirry pienoisohjelmassa painamalla F12-näppäintä',
	'f10KeyDescription': 'Avaa pienoisohjelman tarkastelunäkymä painamalla F10-näppäintä',

	'WidgetLabelWithDescripion': '%{label}. %{description}',

	// no longer used in this component, moved to dashboard-livewidget.
	// please don't remove from here, or will break R8
	'summaryLabel': '%{label}, jonka arvo on %{value}',

	'shapeColorLabel': 'Muodon väri',
	'showLegendLabel': 'Näytä selite',

	//Webpage
	'webpageWidgetTitle': 'Web-sivu-pienoisohjelma',
	'webpagePasteLink': 'Liitä URL-osoite ja tallenna se painamalla Enter-näppäintä.',
	'propWebpageLink': 'Web-sivun URL-osoite',
	'propWebpageTitle': 'Web-sivun otsikko',
	'propWebpageTitleDescription': 'Web-sivulla oleva otsikko',
	'webpageUrl': 'Web-sivun URL-osoite',
	'noWebpageSelected': 'Web-sivua ei ole valittu',
	'enterWebpageUrl': 'Anna Web-sivun URL-osoite',
	'propWebpageTop': 'Web-sivun ominaisuudet', // TODO: becomes "Web page" when FF 'PropertiesV2' is enabled
	'webpageMissingUrl': 'Web-sivun URL-osoite puuttuu.',
	'webpageUrlValidationError': 'Web-sivun URL-osoite ei kelpaa.',
	'webpageHttpValidationError': 'Web-sivu on avattava HTTPS-linkin avulla.',
	'webpageInvalidDomainError': 'Web-sivun URL-osoite viittaa verkkoalueeseen, jota pääkäyttäjä ei ole hyväksynyt. Pääkäyttäjän hyväksymät verkkoalueet ovat %{domains}.',

	//VizState
	'vzErrorLoading': 'Visualisoinnin lataus ei onnistu',
	'vzErrorLoadingMissingData': 'Visualisoinnin lataus ei onnistu, kontekstitiedot puuttuvat',

	//Media (Video / Audio)
	'mediaWidgetTitle': 'Multimediasisältö-pienoisohjelma',
	'mediaPasteLink': 'Liitä URL-osoite ja tallenna se painamalla Enter-näppäintä.',
	'mediaUrl': 'Multimediasisällön URL-osoite',
	'noMediaSelected': 'Multimediasisältöä ei ole valittu',
	'enterMediaUrl': 'Anna multimediasisällön URL-osoite',
	'videoHeight': 'Korkeus:',
	'videoWidth': 'Leveys:',
	'propMediaLink': 'Multimediasisällön linkki',
	'propMediaTitle': 'Multimediasisällön otsikko',
	'propMediaTitleDescription': 'Multimediasisällön otsikko',
	'propMediaTop': 'Multimediasisällön ominaisuudet', // TODO: becomes "Media" when FF 'PropertiesV2' is enabled
	'mediaMissingUrl': 'Multimediasisällön linkin URL-osoite puuttuu.',
	'mediaUrlValidationError': 'Multimediatiedoston URL-osoite ei kelpaa.',
	'mediaUnknownValidationError': 'Multimediasisällön tyyppi ei ole tuettu.',
	'mediaHttpValidationError': 'Multimediatiedosto on avattava HTTPS-linkin avulla.',
	'mediaInvalidDomainError': 'Multimediatiedoston URL-osoite viittaa verkkoalueeseen, jota pääkäyttäjä ei ole hyväksynyt. Pääkäyttäjän hyväksymät verkkoalueet ovat %{domains}.',

	// Properties pane
	'commonPropertiesLabel': 'Ominaisuudet', // TODO: no longer needed when FF 'PropertiesV2' is enabled

	// Data strip
	'dataSetsLabel': 'Tietojoukko',
	'dataViewsLabel': 'Näkymä',
	'columnQuality': 'Tietojen laatu',
	'columnProperties': 'Tietojen ominaisuudet',

	'dataQuality': 'Tietojen laatu',
	'dataQualityRowCount': 'Rivien määrä',
	'dataQualityDistribution': 'Jakelu',
	'dataRowLabel': 'Tiedot',

	// Modelling UI
	'typeColumn': 'Tyyppi',
	'modellingColumnType': 'Tyyppi',
	'modellingColumnAggregation': 'Yhdistäminen',
	'modellingColumnUsage': 'Käyttö',
	'modellingColumnSort': 'Lajittelu',
	'modellingColumnFormat': 'Muoto',
	'modellingColumnCategory': 'Luokka',

	// no longer used in this component, moved to dashboard-livewidget.
	// please don't remove from here, or will break R8
	'modellingLoading': 'Ladataan...',

	'modellingProcessing': 'Käsitellään...',
	'modellingImport': 'Tuonti',
	'modellingReimport': 'Uudelleentuonti',
	'modellingDatasourceTitle': 'Tietolähde',
	'modellingImportStartedTitle': 'Tuonti on alkanut',
	'modellingImportStartedText': 'Tietojen tuonti saattaa kestää jonkin aikaa.\n\n(Voit luoda näkymän tietojen tuonnin aikana.)',
	'importDatasourceTitle': 'Yhteydet',
	'dropHere': 'Luo uusi tietolähde pudottamalla tähän...',
	'browseButton': 'Selaa',
	'errorNoData': 'Käsiteltäviä tietoja ei ole.',
	'errorNoFile': 'Siirrettävää tiedostoa ei ole.',
	'errorUploadFailed': 'Siirto epäonnistui.',
	'uploadSucceessful': 'Siirto onnistui.',
	'del_datasourceTitle': 'Tietojoukon poisto',
	'del_datasourceMsg': 'Haluatko varmasti poistaa kohteen %{name}?',
	'modellingFileUpdate': 'Päivitä',
	'modellingFileUpdateTitle': 'Tietojoukon päivitys',
	'modellingFileUpdateDescription': 'Haluatko päivittää tiedoston %{name}?',
	'modellingFileUpdatingTitle': 'Tiedoston %{name} päivitys on meneillään',
	'modellingUpdateStartedTitle': 'Päivityksen tuonti on alkanut',
	'modellingUpdateStartedText': 'Tietojen päivitys saattaa kestää jonkin aikaa.\n\n(Voit luoda näkymän tietojen päivityksen aikana.)',
	'modellingErrorImportUploadNoFile': 'Ei siirrettävää tiedostoa.',
	'modellingErrorImportUploadFailed': 'Siirto epäonnistui.',
	'modellingErrorImportUploadInvalidType': 'Tiedostotyyppi ei kelpaa.',
	'modellingErrorImportUploadTableFailed': 'Taulukkojen nouto ei onnistu.',
	'modellingIntentResultsTitle': 'Valitse käytettävä ehdotettu tietojoukko',
	'modellingColumnViewRelationships': 'Tarkastele liittyviä taulukoita',
	'modellingTableRelatedTables': 'Kohteeseen %{name} liittyvät taulukot',
	'modellingTable': '%{name} - Taulukko',
	'modellingColumnIncludedInDataSet': 'Lisätty',
	'modellingDataSet': 'Tietojoukko',
	'modellingViewInDataSet': 'Tarkastele tietojoukossa',
	'modellingViewRelatedTables': 'Tarkastele liittyviä',

	// no longer used in this component, moved to dashboard-livewidget.
	// please don't remove from here, or will break R8
	'modellingRelatedTablesNoneFound': 'Liittyviä taulukoita ei löytynyt',

	'modellingValidatingDataset': 'Tarkistus on meneillään...',
	'datasetFinishedRefreshing': 'Tietojoukko %{datasetName} on päivitetty.',



	// Join UI - Navigation Controller titles
	'modellingJoinTable': 'Selvitä liitospolku:',
	'modellingJoinColumns': 'Määritä seuraavan taulukon liitospolku: %{name}',
	'modellingJoinToTable': 'Liitos taulukkoon %{name}',

	// Data Quality
	'excluded': 'Pois jätetyt',
	'metricPrefixThousand': 'K',
	'metricPrefixMillion': 'M',
	'metricPrefixBillion': 'B',
	'metricPrefixTrillion': 'T',
	'metricPrefixQuadrillion': 'Q',

	//Column Flyout
	'modellingColumnFilter': 'Suodatin',
	'modellingColumnSortNone': 'Tyhjennä lajittelu',
	'modellingColumnSortAsc': 'Lajittele nousevasti',
	'modellingColumnSortDesc': 'Lajittele laskevasti',
	'modellingColumnRemove': 'Poista tämä sarake',

	// Import File Browser
	'dropboxPageTitle': 'Uusi Dropbox-yhteys',
	'sizeColumn': 'Koko',

	//Modelling Column Property Values
	'dataType_string': 'Merkkijono',
	'dataType_date': 'Päivämäärä',
	'dataType_integer': 'Kokonaisluku',
	'dataType_double': 'Kaksinkertainen',
	'dataType_float': 'Liukuluku',
	'dataType_boolean': 'Totuusarvo',

	// no longer used in this component, moved to dashboard-livewidget.
	// please don't remove from here, or will break R8
	'defaultAggregation_count': 'Määrä',
	'defaultAggregation_countdistinct': 'Lukujen määrä',
	'defaultAggregation_max': 'Enimmäisarvo',
	'defaultAggregation_min': 'Vähimmäisarvo',
	'defaultAggregation_avg': 'Keskitaso',
	'defaultAggregation_sum': 'Summa',
	'defaultAggregation_auto': 'Automaattinen (%{aggregationType})',

	'type_fact': 'Tosio',
	'type_attribute': 'Määrite',

	'defaultSort_none': 'Älä lajittele',
	'defaultSort_asc': 'Lajittele nousevasti',
	'defaultSort_desc': 'Lajittele laskevasti',

	'category_none': 'Ei mitään',
	'category_location': 'Sijainti',
	'category_monetary': 'Rahallinen',
	'category_time': 'Aika',

	// Root menu
	'rootMenuTitle': 'Päävalikko',

	'errorMessageTitle': 'Virhe',
	'errorMessageDetails': 'Tiedot: ',
	'errorMessageTitleAssetAlreadyExists': 'Omaisuus on jo määritetty',

	'defaultTabTitle': 'Välilehti %{index}',
	'tabAddBtnTitle': 'Lisää uusi välilehti.',
	'defaultInfographicTitle': 'Infografiikka',

	'unsupportedConditionalFormattingEncountered': 'Ehdollista muotoilua ei enää käytetä joissakin sarakkeissa.',


	// Homepage View
	'nameColumn': 'Nimi',
	'creatorColumn': 'Laatinut',
	'creationDateColumn': 'Luontipäivämäärä',
	'versionColumn': 'Versio',
	'modifiedColumn': 'Viimeksi muokattu',

	'filterBy': 'Suodata objektit',
	'allFilter': 'Kaikki kohteet',
	'createdByMeFilter': 'Luotu itse',
	'sharedWithMeFilter': 'Yhteiskäytössä kanssasi',
	'favoritesFilter': 'Omat suosikit',
	'recentsFilter': 'Viimeksi lisätyt',
	'sortBy': 'Lajitteluperuste',

	// Sort Menu
	'sortModified': 'Muokattu',
	'sortUpdated': 'Päivitetty',
	'sortName': 'Nimi',

	'viewAs': 'Näyttömuoto',
	'thumbnailsView': 'Näytä pienoiskuvina',
	'listView': 'Näytä luettelona',
	'createMenu': 'Luo',
	'newAppItem': 'Mittatietotaulu',
	'newDataSet': 'Tietojoukko',

	'menuSelectionState_a11y': 'Kohteen %{item} valitsimeksi on asetettu %{selectedItem}',

	'unableToShareItem': 'Kohteen %{item} määritys yhteiskäyttöön ei onnistu.',
	'toastFetchingContent': 'Noudetaan lisää sisältöä...',
	'unableToGetData': 'Sisällön nouto ei onnistu.',
	'unableToFavorite': 'Suosikki-tilan muutto ei onnistu',
	'hpErrorMissingRequiredOptions': 'Pakollisen alustusasetukset puuttuvat',
	'unableToOpenBoard': 'Kohteen %{name} avaus ei onnistu.',
	'unableToDuplicateBoard': 'Kohteen %{name} kopiointi ei onnistu.',
	'unableToCreateBoard': 'Kohteen %{name} luonti ei onnistu.',
	'unableToCreateBoardNameConflict': 'Samanniminen omaisuus on jo järjestelmässä.',

	// DataSet Detail View
	'status': 'Tila',
	'numberOfRows': 'Rivit',
	'importWarnings': 'Varoitukset',
	'lineNumbers': 'Viivat',
	'excerptFromSource': 'Katkelma',
	'reason': 'Syy',
	'numberOfRowsDropped': 'riviä on ohitettu',
	'oneRowDropped': '1 rivi on ohitettu',

	// Type Menu
	'typeMenuLabel': 'Tyyppi',
	'dashboardsLabel': 'Mittatietotaulut',
	'datasetsLabel': 'Tietojoukot',
	'storiesLabel': 'Tarinat',
	'allLabel': 'Kaikki tyypit',

	// Board Page View App Bar
	'datasets': 'Tietojoukot',
	'settings': 'Ominaisuudet',
	'add': 'Lisää',
	'widgets': 'Pienoisohjelmat',
	'dashboardProperties': 'Mittatietotaulun ominaisuudet',
	'searchPanel' : 'Hae',
	'pins': 'Kokoelma',
	'pinsOld': 'Omat kiinnitetyt omaisuudet',
	'pinsDateFilterHeading' : 'Kiinnitetty päivämäärä',
	// For languages with more than one plural form, provide the different forms delimited by |||| in the string below.
	// See https://github.com/airbnb/polyglot.js#pluralization
	'pinCount': '%{smart_count} kiinnitys |||| %{smart_count} kiinnitystä',
	'pinSearch': 'Hae',
	'pinSearchOld': 'Hae kiinnitettyjä omaisuuksia',
	'pinListView': 'Luettelonäkymä',
	'pinIconView': 'Kuvakenäkymä',
	'pinRemove': 'Poista',
	'pinCreate': 'Luo',
	'pinDeleteError': 'Kokoelmasta ei voi poistaa yhtä tai useaa omaisuutta. Yritä myöhemmin uudelleen.',
	'pinDeleteErrorOld': 'Yhden tai usean kiinnitetyn kohteen poisto ei onnistu. Yritä myöhemmin uudelleen.',
	'pinRetrieveError': 'Yhden tai usean kiinnitetyn kohteen nouto ei onnistu. Yritä myöhemmin uudelleen.',
	'NoPinsCollected': 'Kiinnitettyjä visualisointeja ei ole',
	'pinDeletedToast': 'Kiinnitys on poistettu',
	'pinRenamedToast': 'Kiinnitys on nimetty uudelleen',
	'pinAddedToast': 'Kiinnitys on lisätty omiin kiinnitettyihin omaisuuksiin',
	'pinningToast': 'Kiinnityksen käsittely on meneillään...',
	'pinDateFilter': 'Päivämääräsuodatin',
	'pinDateFilterAll': 'Kaikki',
	'pinDateFilterToday': 'Tänään',
	'pinDateFilterYesterday': 'Eilen',
	'pinDateFilterPastWeek': 'Viime viikko',
	'pinDateFilterPastMonth': 'Viime kuukausi',
	'pinDateFilterEarlier': 'Aiemmin',

	// data widget contextual toolbar labels
	// no longer used in this component, moved to dashboard-livewidget.
	// please don't remove from here, or will break R8
	'toolbarActionEditTitle': 'Otsikon muokkaus',
	'toolbarActionSort': 'Lajittelu',
	'toolbarActionSortAscending': 'Lajittele nousevasti',
	'toolbarActionSortDescending': 'Lajittele laskevasti',
	'toolbarActionSortAuto': 'Automaattinen (%{sortOrder})',
	'toolbarActionFormat': 'Alusta tiedot',
	'toolbarActionFormatAbbreviation': 'Lyhennä',
	'toolbarActionFormatNone': 'Automaattinen',
	'toolbarActionFilter': 'Suodatin',
	'toolbarActionTopBottom': 'Ylin tai alin',
	'toolbarActionAddShape': 'Lisää muoto',
	'toolbarActionRmvShape': 'Poista muoto',
	'toolbarActionToggleShapeDrop': 'Infografiikan muoto',
	'toolbarActionToggleShapeDropTitle': 'Luo infografiikka',
	'toolbarActionToggleShapeDropText': 'Voit luoda infografiikan vetämällä muodon tähän kenttään.',
	'toolbarActionAggregationType': 'Laske yhteen',
	'toolbarDeleteActionText': 'Poista sarake',
	'toolbarActionFilterLocalKeepSelected': 'Säilytä',
	'toolbarActionFilterLocalExcludeSelected': 'Jätä pois',
	'toolbarActionFilterAllKeepSelected': 'Suodatin',
	'toolbarActionSimpleCalculation': 'Yksinkertainen laskutoimitus',
	'toolbarActionDrillBack': 'Edellinen',
	'toolbarActionDrillUp': 'Poraudu ylöspäin',
	'toolbarActionDrillDown': 'Poraudu alaspäin',
	'toolbarActionNavigate': 'Siirry',
	'toolbarActionCreateFilterGroup': 'Luo uusi yhteys',
	'toolbarActionDisconnectFilterGroup': 'Katkaise kaikki linkit',
	'toolbarActionLinkFilterGroup': 'Lisää aiemmin luotuun yhteyteen',

	'toolbarLabel': '%{labelName}:',
	'toolbarNoValueLabel': '%{labelName}',

	// Side bar
	'sidebarAdd': 'Lisää',
	'sidebarMultiselect': 'Vaihda monivalintaa',

	// no longer used in this component, moved to dashboard-livewidget.
	// please don't remove from here, or will break R8
	'multiselectMsg': 'Valittu %{count}',

	'multiselectWithTotalMsg': '%{count} / %{total}',
	'sidebarGoBack': 'Takaisin',

	//DataSet pane
	'errorLoadingDataSets': 'Tämän tietojoukon lataus ei onnistu',
	'errorLoadingDataSetMetaData': 'Tämän tietojoukon lataus ei onnistu',
	'dataSetPaneLastUpdated': 'Päivitetty viimeksi: %{date}',
	'dataSetPaneDateUnknown': 'Tuntematon',
	'sourcePaneLabel': 'Valitut lähteet',
	'addSourceLabel': 'Lisää lähde',
	'find_label': 'Etsi',
	'navigationPathsLabel': 'Siirtymistoiminnot',

	//widgetlist
	'errorLoadingWidgetList': 'Objektien lataus ei onnistu.',
	'errorLoadingThemeFile': 'Teeman määrityksen lataus ei onnistu',
	'errorLoadingLayoutFile': 'Näkymän lataus ei onnistu.',

	//data widget

	// no longer used in this component, moved to dashboard-livewidget.
	// please don't remove from here, or will break R8
	'dwErrorLoadingAvailableVisualizations': 'Käytettävissä olevien visualisointimääritysten lataus ei onnistu',

	'dwErrorLoadingVisualizationNotFound': 'Objektin lataus ei onnistu, koska siitä puuttuu visualisointimääritys',
	'dwErrorLoadingVisualizationListNotFound': 'Visualisoinnin lataus ei onnistu.',
	'dwErrorRunningQuery': 'Tietojen nouto tietojoukosta %{datasetName} ei onnistu.',
	'dwErrorGeoData': 'Maantieteellisten tietojen näyttämisessä kartalla on ongelma. Valitse toinen visualisointityyppi. ',
	'dwPromptSignonCancelWarning': 'Tämän visualisoinnin tiedot eivät ole käytettävissä. Anna kelvolliset valtuustiedot.',
	'dwErrorMissingDataset': 'Visualisoinnin lataus ei onnistu, koska siihen liittyvä tietojoukko %{datasetName} ei ole käytettävissä.',
	'dwErrorRenderingVisualization': 'Visualisoinnin lataus ei onnistu.',
	'dwErrorVisualizationTooSmall': 'Visualisointi on liian pieni. Se ei voi näyttää sisältämiään tietoja. Suurenna visualisointia tai rajoita sen sisältämiä tietoja.',
	'aria_label_datatable': 'Tietotaulukko',
	'aria_key_navi_datatable_desc': 'Siirry soluihin nuolinäppäimillä. Siirry ensimmäiselle riville painamalla näppäinyhdistelmää Ctrl+Home ja siirry viimeiselle riville painamalla näppäinyhdistelmää Ctrl+End.',
	'geomapUnrecognizedLocations': 'Tuntemattomat sijainnit:',
	'geomapAmbiguousLocations': 'Monitulkintaiset alueet:',

	// custom widget
	'customWidget': 'Mukautettu pienoisohjelma',
	'customWidgetsTitle': 'Mukautetut pienoisohjelmat',
	'noCustomWidgets': 'Ei mukautettuja pienoisohjelmia',

	// Action names
	'toggleContextBar': 'Vaihda kontekstipalkki',
	'delete': 'Poista',
	'share': 'Määritä yhteiskäyttöön',
	'unshare': 'Peruuta yhteiskäyttö',
	'rename': 'Nimeä uudelleen',
	'close': 'Sulje',
	'duplicate': 'Kaksoiskappale',

	// no longer used in this component, moved to dashboard-livewidget.
	// please don't remove from here, or will break R8
	'retry': 'Yritä uudelleen',

	'changeTemplate': 'Muuta malli',

	// Aggregation Types
	'sum': 'Summa',
	'count': 'Määrä',
	'countdistinct': 'Lukujen määrä',
	'avg': 'Keskitaso',
	'min': 'Vähimmäisarvo',
	'max': 'Enimmäisarvo',
	'custom': 'Mukautettu',
	'calculated': 'Laskettu',

	// no longer used in this component, moved to dashboard-livewidget.
	// please don't remove from here, or will break R8

	'aggregatedColumnLabel': '%{column} (%{aggregationTypeLabel})', // For example, the sum of Revenue

	//simple calculation
	'percDifferenceOp': 'Muutos-%',
	//For example, Profit - Expenses
	'calculationTitle': '%{col1} %{operator} %{col2}',

	'templateWidgetPlaceholderInput': 'Visualisointiehdot...',
	'QuickAddResultsHeader': 'Tietojen visualisoinnit',
	'NoQuickAddResults': 'Mikään ei vastannut tarkoitusta. Luodaanko uusi tietojoukko?',
	'NoQuickAddResultsRetry': 'Vastineita ei löydy. Yritä uudelleen toisilla hakuehdoilla.',
	'templateWidgetTitle': 'Malli',

	// no longer used in this component, moved to dashboard-livewidget.
	// please don't remove from here, or will break R8
	'nullValueLabel': '(tyhjä)',

	'nullValueContent': '(ei arvoa)',
	'nullValueText': 'Tyhjä',

	// Modelling / Data Shaping
	'textFilterControlRegionLabel': 'Tekstin suodatin - %{columnName}',

	'textFilterSelectTab': 'Valitse',

	'textFilterConditionTab': 'Määritä ehto',
	'textFilterItemsSelected': '(%{selected})',

	// no longer used in this component, moved to dashboard-livewidget.
	// please don't remove from here, or will break R8
	'textFilterItemsNotFound': 'Kohteita ei ole käytettävissä.',

	'textFilterEquals': 'On yhtä suuri kuin',
	'textFilterContains': 'Sisältää kohteen',
	'textFilterBeginsWith': 'Alkaa',
	'textFilterEndsWith': 'Loppuu',
	'textFilterDoesNotEqual': 'Ei ole yhtä suuri',
	'textFilterDoesNotContain': 'Ei sisällä',
	'textFilterDoesNotBeginWith': 'Ei ala parametrilla',
	'textFilterDoesNotEndWith': 'Ei pääty parametriin',
	'textFilterSampleText': 'Esimerkki: A',

	'textFilterAndButton': 'Ja',
	'textFilterOrButton': 'Tai',

	'dateFilterMessage': 'Valitse päivämääräalue',
	'dateRangeControlRegionLabel': 'Päivämääräalueen suodatin - %{columnName}',
	'dateFilterRangeOption': 'Arvoalue-asetus',
	'dateFilterDateLabel': 'Päivämäärä',
	'dateFilterBlank': '(tyhjä)',
	'dateFilterBefore': 'Ennen',
	'dateFilterAfter': 'Jälkeen',
	'dateFilterBetween': 'Väliltä',
	'dateFilterSampleText': 'VVVV-KK-PP',
	'dateTitle': 'Päivämäärä',
	'dateIncludeBlankLabel': 'Sisällytä tyhjä päivämäärä',

	'timeTitle': 'Aika',
	'timeFilterMessage': 'Valitse aika-alue',
	'dateTimeFilterMessage': 'Valitse päivämäärä- ja aika-alue',

	'topbottomNumberOfResultsLabel': 'Tulosten määrä',
	'topbottomPercentLabel': 'Prosentti',
	'topbottomNumberOfResultsLimit': 'Väliltä %{lower} - %{higher}',
	'topbottomSelectOption': 'Ylin tai alin -asetus',
	'topbottomOptionLabel': 'Näytä',
	'searchByLabel': 'Hakuehto',
	'searchNoMatches': 'Vastineita ei löytynyt',
	'topbottomRankColumnLabel': 'Lisää taulukkoon järjestyssarake',
	'topbottomNone': 'Ei mitään',
	'topCount': 'Ensimmäisten lukumäärä',
	'topPercent': 'Ylin %',
	'bottomCount': 'Viimeisten lukumäärä',
	'bottomPercent': 'Alin %',
	'topbottomSearchColumn': 'Etsi sarake',
	'searchColumnAriaLabel': 'Etsi sarake. Kirjoita haettavan sarakkeen nimi ja etsi sarake luettelosta alanuolinäppäimellä.',
	'rankColumnLabel': 'Luokitus (%{columnLabel})',
	'topbottomClearLabel': 'Tyhjennä',

	'rangeFilterControlRegionLabel': 'Arvoalueen suodatin - %{columnName}',

	// Slider
	'sliderRegionLabel': 'Liukusäädinohjausobjekti, siirrä liukusäätimen kahvoja oikealla ja vasemmalla nuolinäppäimellä',
	'sliderHandleLabel': 'Liukusäätimen kahva',
	'a11ySliderHandleLabel': 'Liukusäätimen kahva %{sliderValue}',
	'sliderInputLabel': 'arvo',

	// Refinery - Hidden columns
	'datasetItemsUnavailable': 'Jotkin tässä visualisoinnissa käytetyt tietojoukkojen kohteet eivät ole käytettävissä.',
	'datasetItemUnavailable': 'Tämä tietojoukon kohde ei ole käytettävissä',

	//Authoring topBottom
	'topOperator': 'Ylhäällä',
	'bottomOperator': 'Alhaalla',
	//For dimension column. eg: Top 5 by Quantity. %{operator} is topOperator or bottomOperator, %{val} is a number and %{fact} is a column name.
	'topBottomFact': '%{operator} %{value} sarakkeen %{columnLabel} mukaan',
	//For fact column. eg: Top 10. %{operator} is topOperator or bottomOperator and %{val} is a number.
	'topBottomDimension': '%{operator} %{value}',
	'topBottomTitle': 'Vain tämä objekti',
	'deleteTopBottom': 'Poista ensimmäisten tai viimeisten lukumäärä',
	'editTopBottom': 'Muokkaa ensimmäisten tai viimeisten lukumäärää',
	'deleteDrillState': 'Poista nykyinen porautumistila',
	'ariaDeleteDrillStateLabel': 'Muokkaa ensimmäisten tai viimeisten lukumäärää painamalla ENTER-näppäintä.',
	'drillUpStateTitle': 'Poraudu ylös',
	'drillDownStateTitle': 'Poraudu alas',
	'ariaEditTopBottomLabel': 'Muokkaa ensimmäisten tai viimeisten lukumäärää painamalla ENTER-näppäintä.',
	'ariaDeleteTopBottomLabel': 'Poista ensimmäisten tai viimeisten lukumäärä painamalla DELETE-näppäintä.',

	// Authoring filtering
	'dimFilterIn': 'Sisältää: %{in}',
	'dimFilterNotIn': 'Ei sisällä: %{out}',
	'measureFilterBetween': 'Väliltä %{lowerBound} - %{upperBound}',
	'measureFilterNotBetween': 'Ei väliltä %{lowerBound} - %{upperBound}',
	'gtFilter': 'Arvon %{lowerBound} jälkeen',
	'ltFilter': 'Ennen arvoa %{upperBound}',
	'notGtFilter': 'Ei arvon %{lowerBound} jälkeen',
	'notLtFilter': 'Ei ennen arvoa %{upperBound}',
	'localFilterTitle': 'Vain tämä objekti',
	'globalFilterTitle': 'Kaikki objektit',
	'deleteFilter': 'Poista suodatin',
	'editFilter': 'Muokkaa suodatinta',
	'ariaEditFilterLabel': 'Muokkaa suodatinta painamalla ENTER-näppäintä.',
	'ariaDeleteFilterLabel': 'Poista suodatin painamalla DELETE-näppäintä.',

	// Prompts
	'ariaEditPrompt': 'Muuta kehotearvoa painamalla ENTER-näppäintä',

	'moreDataIndicator': 'Tiedot on leikattu %{threshold} kohteen jälkeen. Näytä vähemmän tietoja suodattamalla.',

	// data point filtering
	'dataPointFilterTitle': 'Tietopisteet',
	'dataPointFilterIncludeSummary': 'Sisällytetyt tietopisteet: %{valueCount}',
	'dataPointFilterExcludeSummary': 'Pois jätetyt tietopisteet: %{valueCount}',

	// DB2 connection page
	'db2Database': 'DB2-tietokanta (%{jdbcConnection})',
	'db2Title': 'Yhteyden muodostus IBM DB2 -tietokantaan',

	// Database
	'databaseConnectionMessage': 'Anna tietokantayhteyden tiedot:',
	'connectionString': 'Tietokannan yhteysmerkkijono',
	'databaseCredentials': 'Valtuustiedot: ',
	'databaseUserName': 'Käyttäjätunnus',
	'databasePassword': 'Salasana',
	'databaseConnect': 'Yhdistä',

	// Twitter Keyword page
	'twitterTitle': 'Twitter',
	'twitterKeywordMessage': 'Anna hakuehto:',
	'twitterKeyword': 'Avainsana',
	'twitterSearch': 'Hae',

	// NewConnectionView Providers
	'twitterProvider': 'Twitter',
	'dropboxProvider': 'Dropbox',
	'db2Provider': 'DB2',

	'workbookCreateFailed': 'Näkymän luonti ei onnistu: %{error}\nToiminto epäonnistui: %{lastOp}',

	// Expanded View, Focus View
	// no longer used in this component, moved to dashboard-livewidget.
	// please don't remove from here, or will break R8
	'widgetFiltersLabel': 'Pienoisohjelman suodattimet',
	'missingColumn': 'Puuttuva: %{columnLabel}',
	'missingFiltering': 'Seuraavilta sarakkeen tunnuksilta puuttuu suodattimia:',
	'heatByLabel': 'Lämmön peruste',
	'evColumns': 'Sarakkeet',
	'evLocalFilters': 'Paikalliset suodattimet',
	'evExpand': 'Laajenna',
	'evFilterTooltip': 'Suodatin',
	'evAdd': 'Lisää sarake',

	// Navigation View
	'navigationBack': 'Edellinen',

	// Pinning
	'contentPinFail': 'Sisällön keräys ei onnistu. Yritä myöhemmin uudelleen.',
	'contentPinFailOld': 'Sisällön kiinnitys ei onnistu. Yritä myöhemmin uudelleen.',
	'pinRenameFail': 'Kiinnitystä ei voi nimetä uudelleen. Yritä myöhemmin uudelleen.',

	// Layouts
	'dropZoneLabel': 'Suurenna kohde pudottamalla se tähän',

	//Share
	'shareDefaultPageTitle': 'Sivu %{index}',

	'nextPage': 'Seuraava sivu',
	'previousPage': 'Edellinen sivu',

	'assetAssembly': 'näkymät',

	'toolbar_save': 'Tallenna',
	'brgr_saveAs': 'Tallenna nimellä',
	'brgr_refresh': 'Päivitä',

	// Save
	'saving': 'Tallennetaan...',
	'save_success': 'Näkymä on tallennettu.',
	'save_failure': 'Pahoittelemme. Näkymän tallennus ei onnistunut. Yritä myöhemmin uudelleen.',
	'dashboard_save_success': 'Mittatietotaulu on tallennettu.',

	'geminiLeave': 'Olet lopettamassa IBM Watson Analytics -ohjelman käytön.',

	'warning': 'Varoitus',
	'missingDataSetData': 'Tämän tietojoukon tiedot eivät ole käytettävissä. Päivitä tietojoukko, tai pyydä pääkäyttäjältä lähteen käyttöoikeus.',

	// Calculations
	'error_calculation_in_use': 'Valittu laskutoimitus on käytössä, eikä sitä voi siksi poistaa.',

	'resize': 'Muuta kokoa',
	'rotate': 'Kierrä',
	'moveHandle': 'Siirrä pienoisohjelmaa',
	'expandHandle': 'Laajenna',
	'panHandle': 'Vaakavieritä',

	//Navigation
	// no longer used in this component, moved to dashboard-livewidget.
	// please don't remove from here, or will break R8
	'navigateTitle': 'Siirry kohteeseen',

	// Slide out titles
	'shapeSlideoutTitle': 'Muodot',
	'textSlideoutTitle': 'Teksti',
	'mediaSlideoutTitle': 'Multimediasisältö',
	'visualizationSlideoutTitle': 'Visualisoinnit',

	// Board Model Dialog Messages
	'invalidJSONResponse': 'Annettu JSON ei kelpaa. Katso lisätietoja virhelokista.',

	// Widget type labels
	'shape_label': 'Muoto',
	'image_label': 'Kuva',
	'data_label': 'Kaavio',
	'media_label': 'Multimediasisältö',
	'text_label': 'Teksti',
	'embedMedia_label': 'Multimediasisältö',
	'youtube_label': 'YouTube-video',
	'webpage_label': 'Web-sivu',

	// **** Smart names for objects ****
	// You might think that one_name is useless, but we have it in case we need to change that resource into one_name_numbered
	'one_name': '%{name}',
	'one_name_numbered': '%{name} (%{number})',
	'noExtraText_shape': 'Muoto',
	'noExtraText_shape_numbered': 'Muoto (%{number})',
	'few_shape': '%{count} muodon ryhmä',
	'many_shape': '%{count} muodon ryhmä',
	// %{text} is the description of the image, specified in the properties by the user
	'one_image': 'Kuva %{text}',
	'one_image_numbered': 'Kuva %{text} (%{number})',
	'noExtraText_image': 'Kuva',
	'noExtraText_image_numbered': 'Kuva (%{number})',
	'few_image': '%{count} kuvan ryhmä',
	'many_image': '%{count} kuvan ryhmä',
	'noExtraText_text': 'Tyhjä tekstiruutu',
	'noExtraText_text_numbered': 'Tyhjä tekstiruutu (%{number})',
	'few_text': '%{count} tekstiruudun ryhmä',
	'many_text': '%{count} tekstiruudun ryhmä',
	//pa cube viewer
	'pacubeviewer_no_mapping': 'Kuution tarkasteluohjelma',
	'pacubeviewer_named': 'Kuution tarkasteluohjelma %{name}',
	// Crosstab: values by Row1 (and Column1)
	'crosstab_opt_mapping': 'Ristiintaulukointi %{values} - %{row_level1} ja %{column_level1}',
	'crosstab_opt_mapping_numbered': 'Ristiintaulukointi %{values} - %{row_level1} ja %{column_level1} (%{number})',
	'crosstab_has_mapping': 'Ristiintaulukointi %{values} - %{row_level1}',
	'crosstab_has_mapping_numbered': 'Ristiintaulukointi %{values} - %{row_level1} (%{number})',
	'crosstab_no_mapping': 'Tyhjä ristiintaulukointi',
	'crosstab_no_mapping_numbered': 'Tyhjä ristiintaulukointi (%{number})',
	'crosstab_named': 'Ristiintaulukointi %{name}',
	'crosstab_named_numbered': 'Ristiintaulukointi %{name} (%{number})',
	// Grid: first column grid
	'JQGrid_has_mapping': 'Taulukko %{grid_cols}',
	'JQGrid_has_mapping_numbered': 'Taulukko %{grid_cols} (%{number})',
	'JQGrid_no_mapping': 'Tyhjä taulukko',
	'JQGrid_no_mapping_numbered': 'Tyhjä taulukko (%{number})',
	'JQGrid_named': 'Taulukko %{name}',
	'JQGrid_named_numbered': 'Taulukko %{name} (%{number})',
	// Hierarchy: level one hierarchy
	'hierarchy_has_mapping': 'Hierarkia %{level1}',
	'hierarchy_has_mapping_numbered': 'Hierarkia %{level1} (%{number})',
	'hierarchy_no_mapping': 'Tyhjä hierarkia',
	'hierarchy_no_mapping_numbered': 'Tyhjä hierarkia (%{number})',
	'hierarchy_named': 'Hierarkia %{name}',
	'hierarchy_named_numbered': 'Hierarkia %{name} (%{number})',
	// Legacy map: Region heat by Regions map
	'map_has_mapping': 'Kartta %{categories}',
	'map_has_mapping_numbered': 'Kartta %{categories} (%{number})',
	'map_no_mapping': 'Tyhjä kartta',
	'map_no_mapping_numbered': 'Tyhjä kartta (%{number})',
	'map_named': 'Kartta %{name}',
	'map_named_numbered': 'Kartta %{name} (%{number})',
	// Summary value: value summary value
	'summary_has_mapping': 'Kokonaissumman arvo %{actual}',
	'summary_has_mapping_numbered': 'Kokonaissumman arvo %{actual} (%{number})',
	'summary_no_mapping': 'Tyhjä kokonaissumman arvo',
	'summary_no_mapping_numbered': 'Tyhjä kokonaissumman arvo (%{number})',
	'summary_named': 'Kokonaissumman arvo %{name}',
	'summary_named_numbered': 'Kokonaissumman arvo %{name} (%{number})',

	// KPI: actual value, optional time
	'kpi_opt_mapping': 'Avainlukumittari %{actual} - %{sparkline.time}',
	'kpi_opt_mapping_numbered': 'Avainlukumittari %{actual} - %{sparkline.time} (%{number})',
	'kpi_has_mapping': 'Avainlukumittari %{actual}',
	'kpi_has_mapping_numbered': 'Avainlukumittari %{actual} (%{number})',
	'kpi_no_mapping': 'Tyhjä avainlukumittari',
	'kpi_no_mapping_numbered': 'Tyhjä avainlukumittari (%{number})',
	'kpi_named': 'Avainlukumittari %{name}',
	'kpi_named_numbered': 'Avainlukumittari %{name} (%{number})',

	// (Infographic summary) Infographic: value infographic
	'infographicSummary_has_mapping': 'Infografiikka %{actual}',
	'infographicSummary_has_mapping_numbered': 'Infografiikka %{actual} (%{number})',
	'infographicSummary_no_mapping': 'Tyhjä infografiikka',
	'infographicSummary_no_mapping_numbered': 'Tyhjä infografiikka (%{number})',
	'infographicSummary_named': 'Infografiikka %{name}',
	'infographicSummary_named_numbered': 'Infografiikka %{name} (%{number})',
	'noExtraText_youtube': 'YouTube-video',
	'noExtraText_youtube_numbered': 'YouTube-video (%{number})',
	// %{text} is the user-provided title of the video
	'one_youtube': 'YouTube-video %{text}',
	'one_youtube_numbered': 'YouTube-video %{text} (%{number})',
	'few_youtube': '%{count} YouTube-videon ryhmä',
	'many_youtube': '%{count} YouTube-videon ryhmä',
	'noExtraText_embedMedia': 'Multimediasisällön linkki',
	'noExtraText_embedMedia_numbered': 'Multimediasisällön linkki (%{number})',
	// %{text} is the user-provided title of the media link
	'one_embedMedia': 'Multimediasisällön linkki %{text}',
	'one_embedMedia_numbered': 'Multimediasisällön linkki %{text} (%{number})',
	'few_embedMedia': '%{count} multimediasisältölinkin ryhmä',
	'many_embedMedia': '%{count} multimediasisältölinkin ryhmä',
	'noExtraText_media': 'Multimediasisältö',
	'noExtraText_media_numbered': 'Multimediasisältö (%{number})',
	// %{text} is the user-provided title of the media link
	'one_media': 'Multimediasisältö %{text}',
	'one_media_numbered': 'Multimediasisältö %{text} (%{number})',
	'few_media': '%{count} multimediasisällön ryhmä',
	'many_media': '%{count} multimediasisällön ryhmä',
	'noExtraText_webpage': 'Web-sivu',
	'noExtraText_webpage_numbered': 'Web-sivu (%{number})',
	// %{text} is the user-provided title of the web page
	'one_webpage': 'Web-sivu %{text}',
	'one_webpage_numbered': 'Web-sivu %{text} (%{number})',
	'few_webpage': '%{count} Web-sivun ryhmä',
	'many_webpage': '%{count} Web-sivun ryhmä',
	'one_unknown': 'Objekti',
	'one_unknown_numbered': 'Objekti (%{number})',
	'few_unknown': '%{count} objektin ryhmä',
	'many_unknown': '%{count} objektin ryhmä',

	//a11y label for the left/right arrow for navigation path

	// no longer used in this component, moved to dashboard-livewidget.
	// please don't remove from here, or will break R8
	'next': 'Seuraava',
	'previous': 'Edellinen',
	//a11y description

	// no longer used in this component, moved to dashboard-livewidget.
	// please don't remove from here, or will break R8
	'current_nav_group': 'Nykyinen navigointiryhmä on %{navigation_group_name}',

	//Page Context
	'filterBlank': '(tyhjä)',

	// no longer used in this component, moved to dashboard-livewidget.
	// please don't remove from here, or will break R8
	'errMsgFilterItemGenericTitle': 'Suodattimen arvojen lataus ei onnistu',
	'editTimelineHighlight': 'Muokkaa korostusta',

	'filterDockChevronLeft': 'Vieritä tietoja',
	'filterDockChevronRight': 'Vieritä tietoja',
	'expand': 'Laajenna',
	'collapse': 'Tiivistä',

	//Reset Dashboard
	'dashboardResetTitle': 'Palauta mittatietotaulu',
	'dashboardResetMessage': 'Haluatko varmasti palauttaa kaikki tämän mittatietotaulun muutokset?',
	'dashboardResetToast': 'Mittatietotaulu on palautettu.',

	//Generate PDF
	'buildingPDF': 'Muodostetaan PDF-tiedostoa...',
	'exportPDF': 'Vie PDF-tiedostoon',
	'pageSize': 'Sivun koko',
	'orientation': 'Suunta',
	'filtersPresentPDF': 'Suodattimet, joita on käytetty visualisointeihin edellisellä sivulla:',
	'errorPDF': 'PDF-tiedoston luonti ei onnistu. Päivitä ja yritä uudelleen.',
	'errorPrintPDF': 'PDF-tiedoston luonti ei onnistu. Yritä uudelleen.',
	'printPDFInfo': 'Näytä käyttöohjeet',
	'pdfWidget': 'Pienoisohjelma',
	'includeFilters': 'Näytä suodattimen tiedot',
	'portrait': 'Pysty',
	'landscape': 'Vaaka',
	'letter': 'Letter',
	'legal': 'Legal',
	'a4':'A4',
	'tabloid':'Tabloid',

	'toastUpgradeDone': 'Mittatietotaulusi on päivitetty. Tallenna nyt, jotta optimaalinen suorituskyky säilyy.',

	'migratingDashboard': 'Mittatietotaulun tiedot on siirrettävä. Mittatietotaulu tallentuu, kun siirto on valmis...',
	'migrateDone': 'Mittatietotaulun tiedot on siirretty.',
	'migrateNoPermission': 'Mittatietotaulun tiedot on siirrettävä. Tähän tarvitaan kirjoitusoikeudet. Visualisointien hahmonnuksessa ilmenee virhe.',
	'migratingDataSourcesFailed': 'Vähintään yhden tietolähteen tietojen siirto epäonnistui',

	'ariaFullScreenMessage': 'Poistu koko näytön tilasta painamalla Esc-näppäintä',

	/**********************************************
	*******************LIVE WIDGET*****************
	***********************************************/
	// Hierarchy Packed Bubble
	'LIVE_hierarchy_packed_bubble_has_mapping': '%{categories} hierakkinen kuplarykelmäkaavio',
	'LIVE_hierarchy_packed_bubble_has_mapping_numbered': '%{categories} hierakkinen kuplarykelmäkaavio (%{number})',
	'LIVE_hierarchy_packed_bubble_no_mapping': 'Tyhjä hierakkinen kuplarykelmäkaavio',
	'LIVE_hierarchy_packed_bubble_no_mapping_numbered': 'Tyhjä hierakkinen kuplarykelmäkaavio (%{number})',
	'LIVE_hierarchy_packed_bubble_named': '%{name} hierakkinen kuplarykelmäkaavio',
	'LIVE_hierarchy_packed_bubble_named_numbered': '%{name} hierakkinen kuplarykelmäkaavio (%{number})',

	// Marimekko
	'LIVE_marimekko_has_mapping': 'Marimekko-kaavio %{categories} - %{values}',
	'LIVE_marimekko_has_mapping_numbered': 'Marimekko-kaavio %{categories} - %{values} (%{number})',
	'LIVE_marimekko_no_mapping': 'Tyhjä Marimekko-kaavio',
	'LIVE_marimekko_no_mapping_numbered': 'Tyhjä Marimekko-kaavio (%{number})',
	'LIVE_marimekko_named': 'Marimekko-kaavio %{name}',
	'LIVE_marimekko_numbered': 'Marimekko-kaavio %{name} (%{number})',

	// Sunburst
	'LIVE_sunburst_has_mapping': 'Auringonsädekaavio %{values}',
	'LIVE_sunburst_has_mapping_numbered': 'Auringonsädekaavio %{values} (%{number})',
	'LIVE_sunburst_no_mapping': 'Tyhjä auringonsädekaavio',
	'LIVE_sunburst_no_mapping_numbered': 'Tyhjä auringonsädekaavio (%{number})',
	'LIVE_sunburst_named': 'Auringonsädekaavio %{name}',
	'LIVE_sunburst_named_numbered': 'Auringonsädekaavio %{name} (%{number})',

	// Driver Analysis
	'LIVE_decision_analysis_has_mapping': 'Vaikutinanalyysikaavio %{values}',
	'LIVE_decision_analysis_has_mapping_numbered': 'Vaikutinanalyysikaavio %{values} (%{number})',
	'LIVE_decision_analysis_no_mapping': 'Tyhjä vaikutinanalyysikaavio',
	'LIVE_decision_analysis_no_mapping_numbered': 'Tyhjä vaikutinanalyysikaavio (%{number})',
	'LIVE_decision_analysis_named': 'Vaikutinanalyysikaavio %{name}',
	'LIVE_decision_analysis_named_numbered': 'Vaikutinanalyysikaavio %{name} (%{number})',

	// Line and Column
	'LIVE_line_column_opt_mapping': 'Viiva- ja pylväskaavio %{categories} - %{columnValue} ja %{lineValue}',
	'LIVE_line_column_opt_mapping_numbered': 'Viiva- ja pylväskaavio %{categories} - %{columnValue} ja %{lineValue} (%{number})',
	'LIVE_line_column_has_mapping': 'Viiva- ja pylväskaavio %{columnValue} ja %{lineValue}',
	'LIVE_line_column_has_mapping_numbered': 'Viiva- ja pylväskaavio %{categories} - %{columnValue} ja %{lineValue} (%{number})',
	'LIVE_line_column_no_mapping': 'Tyhjä viiva - ja pylväskaavio',
	'LIVE_line_column_no_mapping_numbered': 'Tyhjä viiva- ja pylväskaavio (%{number})',
	'LIVE_line_column_named': 'Viiva- ja pylväskaavio %{name}',
	'LIVE_line_column_named_numbered' : 'Viiva- ja pylväskaavio %{name} (%{number})',

	// Bubble chart
	'LIVE_bubble_chart_has_mapping': 'Kuplakaavio %{x} - %{y} ja %{size}',
	'LIVE_bubble_chart_has_mapping_numbered': 'Kuplakaavio %{x} - %{y} ja %{size} (%{number})',
	'LIVE_bubble_chart_no_mapping': 'Tyhjä kuplakaavio',
	'LIVE_bubble_chart_no_mapping_numbered': 'Tyhjä kuplakaavio (%{number})',
	'LIVE_bubble_chart_named': 'Kuplakaavio %{name}',
	'LIVE_bubble_chart_named_numbered': 'Kuplakaavio %{name} (%{number})',

	// Bullet chart
	'LIVE_bullet_has_mapping': 'Tavoitearvokaavio %{actual}',
	'LIVE_bullet_has_mapping_numbered': 'Tavoitearvokaavio %{actual} (%{number})',
	'LIVE_bullet_no_mapping': 'Tyhjä tavoitearvokaavio',
	'LIVE_bullet_no_mapping_numbered': 'Tyhjä tavoitearvokaavio (%{number})',
	'LIVE_bullet_named': 'Tavoitearvokaavio %{name}',
	'LIVE_bullet_named_numbered': 'Tavoitearvokaavio %{name} (%{number})',

	// powered by feature
	'ibmDb2': 'IBM Db2',
	'dashboardPoweredByPrefix': 'Tämän mittatietotaulun tietolähde:',
	'showFooterToggleButtonText': 'Näytä alatunniste',
	'showFooterSectionText': 'Alatunniste'

});
